import {FORM_CONSTANTS} from '@/components/DataGrid/FormBuilder/config/constants'
import {CONTROL_TYPES} from '@/components/DataGrid/FormBuilder/config/control_constant'
import {Hooks} from '@/components/DataGrid/FormBuilder/template/components/hook_lists'

// form builder extension
import { faTable } from '@fortawesome/free-solid-svg-icons/faTable'
import GUILookUpFieldControl from '@/components/DataGrid/form-builder-extension/lookup/GUILookUpFieldControl'
import TEMPLATELookUpFieldControl from '@/components/DataGrid/form-builder-extension/lookup/TEMPLATELookUpFieldControl'
import SIDEBARLookUpFieldControl from '@/components/DataGrid/form-builder-extension/lookup/SIDEBARLookUpFieldControl'
import GUIMultiLookUpFieldControl from '@/components/DataGrid/form-builder-extension/multi_lookup/GUIMultiLookUpFieldControl'
import TEMPLATEMultiLookUpFieldControl from '@/components/DataGrid/form-builder-extension/multi_lookup/TEMPLATEMultiLookUpFieldControl'
import SIDEBARMultiLookUpFieldControl from '@/components/DataGrid/form-builder-extension/multi_lookup/SIDEBARMultiLookUpFieldControl'
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile'
import GUIFilesFieldControl from '@/components/DataGrid/form-builder-extension/files/GUIFilesFieldControl'
import TEMPLATEFilesFieldControl from '@/components/DataGrid/form-builder-extension/files/TEMPLATEFilesFieldControl'
import SIDEBARFilesFieldControl from '@/components/DataGrid/form-builder-extension/files/SIDEBARFilesFieldControl'
import { faCode } from '@fortawesome/free-solid-svg-icons/faCode'
import GUICustomFieldControl from '@/components/DataGrid/form-builder-extension/custom/GUICustomFieldControl'
import TEMPLATECustomFieldControl from '@/components/DataGrid/form-builder-extension/custom/TEMPLATECustomFieldControl'
import SIDEBARCustomFieldControl from '@/components/DataGrid/form-builder-extension/custom/SIDEBARCustomFieldControl'
import { faUserCircle } from '@fortawesome/free-solid-svg-icons/faUserCircle'
import GUIUserFieldControl from '@/components/DataGrid/form-builder-extension/user/GUIUserFieldControl'
import TEMPLATEUserFieldControl from '@/components/DataGrid/form-builder-extension/user/TEMPLATEUserFieldControl'
import SIDEBARUserFieldControl from '@/components/DataGrid/form-builder-extension/user/SIDEBARUserFieldControl'
import { faFont } from '@fortawesome/free-solid-svg-icons/faFont'
import GUIMultilineTextFieldControl from '@/components/DataGrid/form-builder-extension/multiline_text/GUIMultilineTextFieldControl'
import TEMPLATEMultilineTextFieldControl from '@/components/DataGrid/form-builder-extension/multiline_text/TEMPLATEMultilineTextFieldControl'
import SIDEBARMultilineTextFieldControl from '@/components/DataGrid/form-builder-extension/multiline_text/SIDEBARMultilineTextFieldControl'
import { faImage } from '@fortawesome/free-solid-svg-icons/faImage'
import GUIProfileImageFieldControl from '@/components/DataGrid/form-builder-extension/profile_image/GUIProfileImageFieldControl'
import TEMPLATEProfileImageFieldControl from '@/components/DataGrid/form-builder-extension/profile_image/TEMPLATEProfileImageFieldControl'
import SIDEBARProfileImageFieldControl from '@/components/DataGrid/form-builder-extension/profile_image/SIDEBARProfileImageFieldControl'

export default {
  moreControls: {
    lookup: {
        label: 'Look Up Field',
        icon: faTable,
        source: {
            gui: GUILookUpFieldControl,
            template: TEMPLATELookUpFieldControl,
            config: SIDEBARLookUpFieldControl
        }
    },
    multi_lookup: {
        label: 'Multi Look Up Field',
        icon: faTable,
        source: {
            gui: GUIMultiLookUpFieldControl,
            template: TEMPLATEMultiLookUpFieldControl,
            config: SIDEBARMultiLookUpFieldControl
        }
    },
    files: {
        label: 'Files Field',
        icon: faFile,
        source: {
            gui: GUIFilesFieldControl,
            template: TEMPLATEFilesFieldControl,
            config: SIDEBARFilesFieldControl
        }
    },
    custom: {
        label: 'Custom Field',
        icon: faCode,
        source: {
            gui: GUICustomFieldControl,
            template: TEMPLATECustomFieldControl,
            config: SIDEBARCustomFieldControl
        }
    },
    user: {
        label: 'User Field',
        icon: faUserCircle,
        source: {
            gui: GUIUserFieldControl,
            template: TEMPLATEUserFieldControl,
            config: SIDEBARUserFieldControl
        }
    },
    multiline_text: {
        label: 'Multiline Text Field',
        icon: faFont,
        source: {
            gui: GUIMultilineTextFieldControl,
            template: TEMPLATEMultilineTextFieldControl,
            config: SIDEBARMultilineTextFieldControl
        }
    },
    profile_image: {
        label: 'Profile Image Field',
        icon: faImage,
        source: {
            gui: GUIProfileImageFieldControl,
            template: TEMPLATEProfileImageFieldControl,
            config: SIDEBARProfileImageFieldControl
        }
    }
  }
}